import { css } from '@emotion/react'

const fullWidth = css`
  max-width: 100%;
`
const emailBody = theme => css`
  border: 1px solid ${theme.color.monochrome.medium};
  border-radius: 6px;
`

export const styles = {
  fullWidth,
  emailBody,
}
